module.exports = __webpack_public_path__ + "img/up.f59addd7.svg";